<template>
  <div class="screen-adapter">
    <div class="content-wrap" :style="style">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenAdapter',
  props: {
    w: { // 设计图尺寸宽
      type: [Number, String],
      default: 1920,
    },
    h: { // 设计图尺寸高
      type: [Number, String],
      default: 1080,
    },
  },
  data() {
    return {
      style: {
        width: `${this.w}px`,
        height: `${this.h}px`,
        transform: 'scale(1)', // 默认不缩放
      },
    };
  },
  mounted() {
    this.setScale();
    this.onresize = this.debounce(() => this.setScale(), 100);
    window.addEventListener('resize', this.onresize);
  },
  methods: {
    // 防抖
    debounce(fn, t) {
      const delay = t || 500;
      let timer;
      // eslint-disable-next-line func-names
      return function () {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },
    // 获取缩放比例
    getScale() {
      const w = window.innerWidth / this.w;
      const h = window.innerHeight / this.h;
      return w < h ? w : h;
    },
    // 设置缩放比例
    setScale() {
      const scale = window.innerWidth / this.w;
      this.style.transform = `scale(${scale})`;
      const h = this.h *scale;
      this.style.height = `${h}px`;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onresize);
  },
};
</script>

<style lang="scss">
.screen-adapter {
  position: relative;
  width: 100vw;
  height: 100vh;
  min-height: 100%;
  max-height: 100vh;
  overflow: hidden auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .content-wrap {
    transform-origin: 0 0;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/frame/ScreenAdapter.vue